import { request } from '@reflex/ui/client/http';
import type {
  CreateNotificationRequest,
  ListNotificationsResponse,
  Notification,
} from '../shared/types.js';

export interface AdminOrganizationOption {
  id: string;
  name: string;
  slug: string;
}

export interface AdminUserOption {
  id: string;
  login: string;
  name?: string | null;
  email?: string | null;
}

export const notificationsApi = {
  list: () => request<ListNotificationsResponse>('/notifications'),
  listAll: () => request<ListNotificationsResponse>('/notifications/admin/all'),
  get: (id: string) => request<Notification>(`/notifications/${encodeURIComponent(id)}`),
  dismiss: (id: string) =>
    request<{ ok: boolean }>(`/notifications/${encodeURIComponent(id)}/dismiss`, {
      method: 'POST',
    }),
  retract: (id: string) =>
    request<{ ok: boolean }>(`/notifications/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    }),
  publish: (body: CreateNotificationRequest) =>
    request<Notification>('/notifications', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  listAllOrganizations: () =>
    request<{ items: AdminOrganizationOption[] }>('/admin/organizations?pageSize=100').then(
      (response) => response.items,
    ),
  listUsers: () => request<AdminUserOption[]>('/users'),
};
